// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoices-manager {
    --invoice-border: #d9dedb;
    --invoice-muted: #65746e;
    --invoice-panel: #ffffff;
    --invoice-panel-soft: #f7f9f8;
    --invoice-text: #1d2e23;
    /* Aligned to the app's standard palette (public/css/index.css): danger for anything that
     * genuinely needs attention, accent for selection/CTA states. Replaces a one-off brown
     * (#4e0f00) that didn't match anything else in the dashboard. */
    --invoice-red: var(--color-danger-text, #721c24);
    --invoice-accent: var(--color-accent, #316c29);
    --invoice-accent-hover: var(--color-accent-hover, #74bb50);
}
[data-theme="dark"] .invoices-manager {
    --invoice-border: #3a463e;
    --invoice-muted: #9fb0a6;
    --invoice-panel: #1c2620;
    --invoice-panel-soft: #222f28;
    --invoice-text: #e3ece6;
    --invoice-red: var(--color-danger-text, #f1a8ae);
}
[data-theme="dark"] .status-badge { color: #cfe3d6; }
[data-theme="dark"] .status-badge.pill { border-color: #3a463e; background: #222f28; }
[data-theme="dark"] .status-paid { border-color: #2c5c3b; background: #16301f; color: #8fd6a0; }
[data-theme="dark"] .status-overdue,
[data-theme="dark"] .status-void,
[data-theme="dark"] .status-canceled,
[data-theme="dark"] .status-uncollectible { border-color: #5c2530; background: #3b1418; color: #f1a8ae; }
[data-theme="dark"] .status-sent,
[data-theme="dark"] .status-viewed,
[data-theme="dark"] .status-partial,
[data-theme="dark"] .status-pending-settlement,
[data-theme="dark"] .status-partial-refunded { border-color: #2d4a63; background: #16232f; color: #8ec2f5; }
[data-theme="dark"] .invoice-form-section { border-color: #3a463e; background: #1c2620; }
[data-theme="dark"] .invoice-form-section__header { border-color: #3a463e; background: #222f28; }
[data-theme="dark"] .invoice-form-section__header h3 { color: #e3ece6; }
[data-theme="dark"] .invoice-form-section__header p { color: #9fb0a6; }
[data-theme="dark"] .invoice-form .invoice-choice { border-color: #3a463e; background: #1c2620; color: #e3ece6; }
[data-theme="dark"] .invoice-line-item-grid--header { color: #9fb0a6; }
[data-theme="dark"] .invoice-line-item-row { border-color: #2c3a33; background: #202b25; }
[data-theme="dark"] .invoice-line-item-field input,
[data-theme="dark"] .invoice-customer-link input,
[data-theme="dark"] .message-compose textarea,
[data-theme="dark"] .note-compose textarea { border-color: #3a463e; background: #1c2620; color: #e3ece6; }
[data-theme="dark"] .invoice-line-item-total { color: #e3ece6; }
[data-theme="dark"] .invoice-summary { border-color: #3a463e; background: #222f28; }
[data-theme="dark"] .invoice-summary div { border-color: #2c3a33; }
[data-theme="dark"] .invoice-summary span:first-child { color: #9fb0a6; }
[data-theme="dark"] .invoice-summary__total { background: #1c2620; }
[data-theme="dark"] .tab-button { border-color: #3a463e; background: #222f28; color: #e3ece6; }
[data-theme="dark"] .invoice-tab-content { border-color: #3a463e; background: #1c2620; }
[data-theme="dark"] .invoice-totals div { border-color: #2c3a33; }
[data-theme="dark"] .invoice-totals .total-row { color: #e3ece6; }
@media (max-width: 700px) {
    [data-theme="dark"] .invoice-line-item-field span,
    [data-theme="dark"] .invoice-line-item-total > span { color: #9fb0a6; }
}

.invoices-manager .button,
.invoice-form .button,
.invoice-detail-actions .button {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;
    line-height: 1;
    white-space: nowrap;
}

/* Icon and label each get their own flex-aligned box (rather than a bare <i> next to a text
 * node) so the icon can never end up taller than the row or drop onto its own line — both
 * symptoms we saw from fa-file-import, a visually denser glyph than fa-plus at the same
 * font-size. */
.invoices-manager .button .button-icon,
.invoice-form .button .button-icon,
.invoice-detail-actions .button .button-icon {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.invoices-manager .button .button-label,
.invoice-form .button .button-label,
.invoice-detail-actions .button .button-label {
    display: inline-block;
    line-height: 1;
}

.invoices-manager .button-icon .fa-file-import {
    font-size: 0.85em;
}

/* Dedicated wrapper for the command-bar's Import/Create pair, isolated from
 * .invoices-commandbar__actions (shared, mobile-stacked) so it can be tuned on its own. */
.invoices-actions {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.invoices-commandbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem;
    margin-bottom: 1rem;
    border: 1px solid var(--invoice-border);
    background: var(--invoice-panel-soft);
}

.invoices-commandbar h3 {
    margin: 0 0 0.25rem 0;
    font-size: 18px;
    color: var(--invoice-text);
}

.invoices-commandbar p {
    margin: 0;
    color: var(--invoice-muted);
    font-size: 14px;
}

.invoices-commandbar__actions {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.invoices-empty .invoices-actions {
    justify-content: center;
    margin-top: 0.25rem;
}

.invoices-summary-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.75rem;
    margin-bottom: 1rem;
}

.invoices-summary-card {
    border: 1px solid var(--invoice-border);
    background: var(--invoice-panel);
    padding: 0.9rem;
    min-width: 0;
}

.invoices-summary-card span {
    display: block;
    margin-bottom: 0.35rem;
    color: var(--invoice-muted);
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0;
}

.invoices-summary-card strong {
    display: block;
    color: var(--invoice-text);
    font-size: 20px;
    line-height: 1.15;
    overflow-wrap: anywhere;
}

.invoices-summary-card--attention strong {
    color: var(--invoice-red);
}

.invoices-list-panel {
    background: var(--invoice-panel);
}

.invoices-toolbar {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem;
    border: 1px solid var(--invoice-border);
    background: var(--invoice-panel-soft);
    margin-bottom: 1rem;
}

.invoices-filters {
    width: min(260px, 100%);
    margin: 0;
}

.invoices-filters label {
    margin-bottom: 0.35rem;
}

.invoices-table-wrapper {
    overflow-x: auto;
}

.invoices-table {
    margin-bottom: 0;
}

.invoices-table th {
    color: var(--invoice-muted);
    font-size: 12px;
    /*text-transform: uppercase;*/
    letter-spacing: 0;
}

.invoices-table td {
    vertical-align: middle;
}

.invoice-number {
    font-weight: 700;
}

.muted {
    color: var(--invoice-muted);
}

.status-badge {
    color: #34443d;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
}
.status-badge.pill {

    display: inline-flex;
    align-items: center;
    min-height: 26px;
    padding: 0.25rem 0.55rem;
    border: 1px solid #cfd8d3;
    background: #f5f7f6;
}

.status-paid {
    border-color: #b7dfbd;
    background: #edf8ef;
    color: #155724;
}

.status-overdue,
.status-void,
.status-canceled,
.status-uncollectible {
    border-color: #efc6ca;
    background: #fff2f3;
    color: #721c24;
}

.status-sent,
.status-viewed,
.status-partial,
.status-pending-settlement,
.status-partial-refunded {
    border-color: #b8daff;
    background: #f0f8ff;
    color: #004085;
}

.invoices-state,
.invoices-empty {
    padding: 2rem;
    text-align: center;
}

.invoices-state--loading {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: var(--invoice-muted);
}

.invoices-empty i {
    color: var(--invoice-muted);
    font-size: 30px;
    margin-bottom: 0.75rem;
}

.invoices-empty h3 {
    margin: 0 0 0.4rem 0;
    font-size: 18px;
}

.invoices-empty p {
    max-width: 420px;
    margin: 0 auto 1rem auto;
    color: var(--invoice-muted);
}

.invoices-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
}

.invoices-pagination span {
    color: var(--invoice-muted);
    font-size: 14px;
}

.invoice-modal.modal--large {
    max-width: 980px;
}

.invoice-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.invoice-form > .group {
    margin-bottom: 0;
}

.invoice-form-section {
    border: 1px solid var(--invoice-border, #d9dedb);
    background: #ffffff;
}

.invoice-form-section__header {
    padding: 0.85rem 1rem;
    border-bottom: 1px solid var(--invoice-border, #d9dedb);
    background: #f7f9f8;
}

.invoice-form-section__header h3 {
    margin: 0;
    font-size: 16px;
    color: #1d2e23;
}

.invoice-form-section__header p {
    margin: 0.25rem 0 0 0;
    color: #65746e;
    font-size: 13px;
}

.invoice-form-section__body {
    padding: 1rem;
}

.invoice-form-grid--two .invoice-subform,
.invoice-form-grid--three .invoice-subform {
    display: grid;
    gap: 1rem;
}

.invoice-form-grid--two .invoice-subform {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.invoice-form-grid--three .invoice-subform {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.invoice-subform .group {
    margin-bottom: 0;
}

.invoice-subform--stacked {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.invoice-payment-summary-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
}

.invoice-choice-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
}

.invoice-form .invoice-choice {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
    width: 100%;
    padding: 0.85rem;
    border: 1px solid #cfd8d3;
    background: #ffffff;
    color: #1d2e23;
    cursor: pointer;
    font-family: "Jost", Arial, sans-serif;
    text-align: left;
}

.invoice-form .invoice-choice:hover {
    border-color: var(--invoice-accent);
    background: var(--invoice-panel-soft);
    color: var(--invoice-text);
}

.invoice-form .invoice-choice.active,
.invoice-form .invoice-choice.active:hover {
    border-color: var(--invoice-accent);
    background: var(--invoice-accent);
    color: #ffffff;
}

.invoice-form .invoice-choice strong {
    font-size: 15px;
}

.invoice-form .invoice-choice span {
    color: inherit;
    font-size: 13px;
    opacity: 0.8;
}

.invoice-line-items-editor {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.invoice-line-item-grid {
    display: grid;
    grid-template-columns: minmax(220px, 1fr) 90px 140px 150px 42px;
    gap: 0.6rem;
    align-items: end;
}

.invoice-line-item-grid--header {
    align-items: center;
    color: #65746e;
    font-size: 12px;
    font-weight: 700;
    /*text-transform: uppercase;*/
    letter-spacing: 0;
}

.invoice-line-item-row {
    padding: 0.6rem;
    border: 1px solid #e3e7e5;
    background: #fbfcfb;
}

.invoice-line-item-field span,
.invoice-line-item-total > span {
    display: none;
}

.invoice-line-item-field {
    margin: 0;
}

.invoice-line-item-field input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    font-family: "Jost", Arial, sans-serif;
    font-size: 0.9rem;
}

.invoice-line-item-total {
    min-height: 37px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #1d2e23;
    font-size: 14px;
}

.invoice-line-item-remove {
    width: 38px;
    min-height: 37px;
    padding: 0;
}

.invoice-line-item-remove:disabled {
    visibility: hidden;
}

.invoice-add-line-item {
    align-self: flex-start;
}

.invoice-summary {
    align-self: flex-end;
    width: min(360px, 100%);
    margin: 0;
    border: 1px solid var(--invoice-border, #d9dedb);
    background: #f7f9f8;
}

.invoice-summary div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.55rem 0.85rem;
    border-bottom: 1px solid #e1e6e3;
    font-size: 14px;
}
.invoice-summary .help {
    padding: 0.5rem;
}

.invoice-summary div:last-child {
    border-bottom: 0;
}

.invoice-summary span:first-child {
    color: #65746e;
}

.invoice-summary__total {
    background: #ffffff;
    font-size: 16px;
}

.invoice-form-alert {
    margin-bottom: 0;
}

.invoice-form-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
    padding-top: 0.25rem;
}

.invoice-detail-actions,
.invoice-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    align-items: center;
    margin-bottom: 1rem;
}
.invoice-detail-actions {
    gap: 1rem;
}

.invoice-customer-link {
    margin-bottom: 1rem;
}

.invoice-customer-link label {
    display: block;
    margin-bottom: 0.35rem;
    font-weight: 700;
}

.invoice-customer-link input,
.message-compose textarea,
.note-compose textarea {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    font-family: "Jost", Arial, sans-serif;
}

.tab-button {
    padding: 0.6rem 0.6rem;
    border: 1px solid var(--invoice-border, #d9dedb);
    background: #f7f9f8;
    color: #1d2e23;
    cursor: pointer;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tab-button.active {
    background: var(--invoice-accent);
    border-color: var(--invoice-accent);
    color: #ffffff;
}

.invoice-tab-content {
    border: 1px solid var(--invoice-border, #d9dedb);
    padding: 1rem;
    background: #ffffff;
}

.invoice-meta {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
    margin-bottom: 1rem;
}

.invoice-line-items-table,
.invoice-tab-content table {
    margin-bottom: 1rem;
}

.invoice-totals {
    margin-left: auto;
    width: min(360px, 100%);
}

.invoice-totals div {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.45rem 0;
    border-bottom: 1px solid #e1e6e3;
}

.invoice-totals .total-row {
    color: #1d2e23;
    font-size: 16px;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

@media (max-width: 900px) {
    .invoices-summary-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .invoice-line-item-grid {
        grid-template-columns: minmax(180px, 1fr) 82px 120px 130px 42px;
    }
}

@media (max-width: 700px) {
    .invoices-commandbar,
    .invoices-commandbar__actions,
    .invoices-actions,
    .invoices-toolbar,
    .invoice-form-actions,
    .invoices-pagination {
        align-items: stretch;
        flex-direction: column;
    }

    .invoices-commandbar .button,
    .invoices-commandbar__actions .button,
    .invoices-actions .button,
    .invoices-toolbar .button,
    .invoice-form-actions .button,
    .invoices-pagination .button {
        width: 100%;
    }

    .invoices-summary-grid,
    .invoice-payment-summary-grid,
    .invoice-choice-grid,
    .invoice-form-grid--two .invoice-subform,
    .invoice-form-grid--three .invoice-subform,
    .invoice-meta {
        grid-template-columns: 1fr;
    }

    .invoice-line-item-grid--header {
        display: none;
    }

    .invoice-line-item-grid {
        grid-template-columns: 1fr 1fr;
    }

    .invoice-line-item-field--description,
    .invoice-line-item-total {
        grid-column: 1 / -1;
    }

    .invoice-line-item-field span,
    .invoice-line-item-total > span {
        display: block;
        margin-bottom: 0.35rem;
        color: #65746e;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
    }

    .invoice-line-item-total {
        align-items: flex-start;
        flex-direction: column;
    }

    .invoice-line-item-remove {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Invoices/Invoices.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,6BAA6B;IAC7B,uBAAuB;IACvB;;oEAEgE;IAChE,gDAAgD;IAChD,8CAA8C;IAC9C,0DAA0D;AAC9D;AACA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,6BAA6B;IAC7B,uBAAuB;IACvB,gDAAgD;AACpD;AACA,oCAAoC,cAAc,EAAE;AACpD,yCAAyC,qBAAqB,EAAE,mBAAmB,EAAE;AACrF,mCAAmC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC/F;;;4CAG4C,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACxG;;;;+CAI+C,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC3G,4CAA4C,qBAAqB,EAAE,mBAAmB,EAAE;AACxF,oDAAoD,qBAAqB,EAAE,mBAAmB,EAAE;AAChG,uDAAuD,cAAc,EAAE;AACvE,sDAAsD,cAAc,EAAE;AACtE,oDAAoD,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAChH,sDAAsD,cAAc,EAAE;AACtE,6CAA6C,qBAAqB,EAAE,mBAAmB,EAAE;AACzF;;;6CAG6C,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACzG,+CAA+C,cAAc,EAAE;AAC/D,uCAAuC,qBAAqB,EAAE,mBAAmB,EAAE;AACnF,2CAA2C,qBAAqB,EAAE;AAClE,wDAAwD,cAAc,EAAE;AACxE,8CAA8C,mBAAmB,EAAE;AACnE,kCAAkC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC9F,2CAA2C,qBAAqB,EAAE,mBAAmB,EAAE;AACvF,0CAA0C,qBAAqB,EAAE;AACjE,iDAAiD,cAAc,EAAE;AACjE;IACI;0DACsD,cAAc,EAAE;AAC1E;;AAEA;;;IAGI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;eAGe;AACf;;;IAGI,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;;IAGI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;0FAC0F;AAC1F;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;IAChC,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,uCAAuC;IACvC,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;;IAII,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;;;IAKI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,uDAAuD;IACvD,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;;IAEI,mCAAmC;IACnC,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,+DAA+D;IAC/D,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,SAAS;IACT,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,wBAAwB;IACxB,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,MAAM;IACN,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,gDAAgD;IAChD,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,gDAAgD;IACpD;;IAEA;QACI,+DAA+D;IACnE;AACJ;;AAEA;IACI;;;;;;QAMI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;;;;;;QAMI,WAAW;IACf;;IAEA;;;;;;QAMI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,cAAc;QACd,sBAAsB;QACtB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".invoices-manager {\n    --invoice-border: #d9dedb;\n    --invoice-muted: #65746e;\n    --invoice-panel: #ffffff;\n    --invoice-panel-soft: #f7f9f8;\n    --invoice-text: #1d2e23;\n    /* Aligned to the app's standard palette (public/css/index.css): danger for anything that\n     * genuinely needs attention, accent for selection/CTA states. Replaces a one-off brown\n     * (#4e0f00) that didn't match anything else in the dashboard. */\n    --invoice-red: var(--color-danger-text, #721c24);\n    --invoice-accent: var(--color-accent, #316c29);\n    --invoice-accent-hover: var(--color-accent-hover, #74bb50);\n}\n[data-theme=\"dark\"] .invoices-manager {\n    --invoice-border: #3a463e;\n    --invoice-muted: #9fb0a6;\n    --invoice-panel: #1c2620;\n    --invoice-panel-soft: #222f28;\n    --invoice-text: #e3ece6;\n    --invoice-red: var(--color-danger-text, #f1a8ae);\n}\n[data-theme=\"dark\"] .status-badge { color: #cfe3d6; }\n[data-theme=\"dark\"] .status-badge.pill { border-color: #3a463e; background: #222f28; }\n[data-theme=\"dark\"] .status-paid { border-color: #2c5c3b; background: #16301f; color: #8fd6a0; }\n[data-theme=\"dark\"] .status-overdue,\n[data-theme=\"dark\"] .status-void,\n[data-theme=\"dark\"] .status-canceled,\n[data-theme=\"dark\"] .status-uncollectible { border-color: #5c2530; background: #3b1418; color: #f1a8ae; }\n[data-theme=\"dark\"] .status-sent,\n[data-theme=\"dark\"] .status-viewed,\n[data-theme=\"dark\"] .status-partial,\n[data-theme=\"dark\"] .status-pending-settlement,\n[data-theme=\"dark\"] .status-partial-refunded { border-color: #2d4a63; background: #16232f; color: #8ec2f5; }\n[data-theme=\"dark\"] .invoice-form-section { border-color: #3a463e; background: #1c2620; }\n[data-theme=\"dark\"] .invoice-form-section__header { border-color: #3a463e; background: #222f28; }\n[data-theme=\"dark\"] .invoice-form-section__header h3 { color: #e3ece6; }\n[data-theme=\"dark\"] .invoice-form-section__header p { color: #9fb0a6; }\n[data-theme=\"dark\"] .invoice-form .invoice-choice { border-color: #3a463e; background: #1c2620; color: #e3ece6; }\n[data-theme=\"dark\"] .invoice-line-item-grid--header { color: #9fb0a6; }\n[data-theme=\"dark\"] .invoice-line-item-row { border-color: #2c3a33; background: #202b25; }\n[data-theme=\"dark\"] .invoice-line-item-field input,\n[data-theme=\"dark\"] .invoice-customer-link input,\n[data-theme=\"dark\"] .message-compose textarea,\n[data-theme=\"dark\"] .note-compose textarea { border-color: #3a463e; background: #1c2620; color: #e3ece6; }\n[data-theme=\"dark\"] .invoice-line-item-total { color: #e3ece6; }\n[data-theme=\"dark\"] .invoice-summary { border-color: #3a463e; background: #222f28; }\n[data-theme=\"dark\"] .invoice-summary div { border-color: #2c3a33; }\n[data-theme=\"dark\"] .invoice-summary span:first-child { color: #9fb0a6; }\n[data-theme=\"dark\"] .invoice-summary__total { background: #1c2620; }\n[data-theme=\"dark\"] .tab-button { border-color: #3a463e; background: #222f28; color: #e3ece6; }\n[data-theme=\"dark\"] .invoice-tab-content { border-color: #3a463e; background: #1c2620; }\n[data-theme=\"dark\"] .invoice-totals div { border-color: #2c3a33; }\n[data-theme=\"dark\"] .invoice-totals .total-row { color: #e3ece6; }\n@media (max-width: 700px) {\n    [data-theme=\"dark\"] .invoice-line-item-field span,\n    [data-theme=\"dark\"] .invoice-line-item-total > span { color: #9fb0a6; }\n}\n\n.invoices-manager .button,\n.invoice-form .button,\n.invoice-detail-actions .button {\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 0.45rem;\n    line-height: 1;\n    white-space: nowrap;\n}\n\n/* Icon and label each get their own flex-aligned box (rather than a bare <i> next to a text\n * node) so the icon can never end up taller than the row or drop onto its own line — both\n * symptoms we saw from fa-file-import, a visually denser glyph than fa-plus at the same\n * font-size. */\n.invoices-manager .button .button-icon,\n.invoice-form .button .button-icon,\n.invoice-detail-actions .button .button-icon {\n    display: inline-flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n.invoices-manager .button .button-label,\n.invoice-form .button .button-label,\n.invoice-detail-actions .button .button-label {\n    display: inline-block;\n    line-height: 1;\n}\n\n.invoices-manager .button-icon .fa-file-import {\n    font-size: 0.85em;\n}\n\n/* Dedicated wrapper for the command-bar's Import/Create pair, isolated from\n * .invoices-commandbar__actions (shared, mobile-stacked) so it can be tuned on its own. */\n.invoices-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.invoices-commandbar {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 1rem;\n    margin-bottom: 1rem;\n    border: 1px solid var(--invoice-border);\n    background: var(--invoice-panel-soft);\n}\n\n.invoices-commandbar h3 {\n    margin: 0 0 0.25rem 0;\n    font-size: 18px;\n    color: var(--invoice-text);\n}\n\n.invoices-commandbar p {\n    margin: 0;\n    color: var(--invoice-muted);\n    font-size: 14px;\n}\n\n.invoices-commandbar__actions {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.invoices-empty .invoices-actions {\n    justify-content: center;\n    margin-top: 0.25rem;\n}\n\n.invoices-summary-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n}\n\n.invoices-summary-card {\n    border: 1px solid var(--invoice-border);\n    background: var(--invoice-panel);\n    padding: 0.9rem;\n    min-width: 0;\n}\n\n.invoices-summary-card span {\n    display: block;\n    margin-bottom: 0.35rem;\n    color: var(--invoice-muted);\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0;\n}\n\n.invoices-summary-card strong {\n    display: block;\n    color: var(--invoice-text);\n    font-size: 20px;\n    line-height: 1.15;\n    overflow-wrap: anywhere;\n}\n\n.invoices-summary-card--attention strong {\n    color: var(--invoice-red);\n}\n\n.invoices-list-panel {\n    background: var(--invoice-panel);\n}\n\n.invoices-toolbar {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 1rem;\n    border: 1px solid var(--invoice-border);\n    background: var(--invoice-panel-soft);\n    margin-bottom: 1rem;\n}\n\n.invoices-filters {\n    width: min(260px, 100%);\n    margin: 0;\n}\n\n.invoices-filters label {\n    margin-bottom: 0.35rem;\n}\n\n.invoices-table-wrapper {\n    overflow-x: auto;\n}\n\n.invoices-table {\n    margin-bottom: 0;\n}\n\n.invoices-table th {\n    color: var(--invoice-muted);\n    font-size: 12px;\n    /*text-transform: uppercase;*/\n    letter-spacing: 0;\n}\n\n.invoices-table td {\n    vertical-align: middle;\n}\n\n.invoice-number {\n    font-weight: 700;\n}\n\n.muted {\n    color: var(--invoice-muted);\n}\n\n.status-badge {\n    color: #34443d;\n    font-size: 12px;\n    font-weight: 700;\n    white-space: nowrap;\n}\n.status-badge.pill {\n\n    display: inline-flex;\n    align-items: center;\n    min-height: 26px;\n    padding: 0.25rem 0.55rem;\n    border: 1px solid #cfd8d3;\n    background: #f5f7f6;\n}\n\n.status-paid {\n    border-color: #b7dfbd;\n    background: #edf8ef;\n    color: #155724;\n}\n\n.status-overdue,\n.status-void,\n.status-canceled,\n.status-uncollectible {\n    border-color: #efc6ca;\n    background: #fff2f3;\n    color: #721c24;\n}\n\n.status-sent,\n.status-viewed,\n.status-partial,\n.status-pending-settlement,\n.status-partial-refunded {\n    border-color: #b8daff;\n    background: #f0f8ff;\n    color: #004085;\n}\n\n.invoices-state,\n.invoices-empty {\n    padding: 2rem;\n    text-align: center;\n}\n\n.invoices-state--loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    color: var(--invoice-muted);\n}\n\n.invoices-empty i {\n    color: var(--invoice-muted);\n    font-size: 30px;\n    margin-bottom: 0.75rem;\n}\n\n.invoices-empty h3 {\n    margin: 0 0 0.4rem 0;\n    font-size: 18px;\n}\n\n.invoices-empty p {\n    max-width: 420px;\n    margin: 0 auto 1rem auto;\n    color: var(--invoice-muted);\n}\n\n.invoices-pagination {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    margin-top: 1rem;\n}\n\n.invoices-pagination span {\n    color: var(--invoice-muted);\n    font-size: 14px;\n}\n\n.invoice-modal.modal--large {\n    max-width: 980px;\n}\n\n.invoice-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.invoice-form > .group {\n    margin-bottom: 0;\n}\n\n.invoice-form-section {\n    border: 1px solid var(--invoice-border, #d9dedb);\n    background: #ffffff;\n}\n\n.invoice-form-section__header {\n    padding: 0.85rem 1rem;\n    border-bottom: 1px solid var(--invoice-border, #d9dedb);\n    background: #f7f9f8;\n}\n\n.invoice-form-section__header h3 {\n    margin: 0;\n    font-size: 16px;\n    color: #1d2e23;\n}\n\n.invoice-form-section__header p {\n    margin: 0.25rem 0 0 0;\n    color: #65746e;\n    font-size: 13px;\n}\n\n.invoice-form-section__body {\n    padding: 1rem;\n}\n\n.invoice-form-grid--two .invoice-subform,\n.invoice-form-grid--three .invoice-subform {\n    display: grid;\n    gap: 1rem;\n}\n\n.invoice-form-grid--two .invoice-subform {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.invoice-form-grid--three .invoice-subform {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.invoice-subform .group {\n    margin-bottom: 0;\n}\n\n.invoice-subform--stacked {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.invoice-payment-summary-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 0.75rem;\n}\n\n.invoice-choice-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.75rem;\n}\n\n.invoice-form .invoice-choice {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n    width: 100%;\n    padding: 0.85rem;\n    border: 1px solid #cfd8d3;\n    background: #ffffff;\n    color: #1d2e23;\n    cursor: pointer;\n    font-family: \"Jost\", Arial, sans-serif;\n    text-align: left;\n}\n\n.invoice-form .invoice-choice:hover {\n    border-color: var(--invoice-accent);\n    background: var(--invoice-panel-soft);\n    color: var(--invoice-text);\n}\n\n.invoice-form .invoice-choice.active,\n.invoice-form .invoice-choice.active:hover {\n    border-color: var(--invoice-accent);\n    background: var(--invoice-accent);\n    color: #ffffff;\n}\n\n.invoice-form .invoice-choice strong {\n    font-size: 15px;\n}\n\n.invoice-form .invoice-choice span {\n    color: inherit;\n    font-size: 13px;\n    opacity: 0.8;\n}\n\n.invoice-line-items-editor {\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n}\n\n.invoice-line-item-grid {\n    display: grid;\n    grid-template-columns: minmax(220px, 1fr) 90px 140px 150px 42px;\n    gap: 0.6rem;\n    align-items: end;\n}\n\n.invoice-line-item-grid--header {\n    align-items: center;\n    color: #65746e;\n    font-size: 12px;\n    font-weight: 700;\n    /*text-transform: uppercase;*/\n    letter-spacing: 0;\n}\n\n.invoice-line-item-row {\n    padding: 0.6rem;\n    border: 1px solid #e3e7e5;\n    background: #fbfcfb;\n}\n\n.invoice-line-item-field span,\n.invoice-line-item-total > span {\n    display: none;\n}\n\n.invoice-line-item-field {\n    margin: 0;\n}\n\n.invoice-line-item-field input {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #ccc;\n    font-family: \"Jost\", Arial, sans-serif;\n    font-size: 0.9rem;\n}\n\n.invoice-line-item-total {\n    min-height: 37px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    color: #1d2e23;\n    font-size: 14px;\n}\n\n.invoice-line-item-remove {\n    width: 38px;\n    min-height: 37px;\n    padding: 0;\n}\n\n.invoice-line-item-remove:disabled {\n    visibility: hidden;\n}\n\n.invoice-add-line-item {\n    align-self: flex-start;\n}\n\n.invoice-summary {\n    align-self: flex-end;\n    width: min(360px, 100%);\n    margin: 0;\n    border: 1px solid var(--invoice-border, #d9dedb);\n    background: #f7f9f8;\n}\n\n.invoice-summary div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0.55rem 0.85rem;\n    border-bottom: 1px solid #e1e6e3;\n    font-size: 14px;\n}\n.invoice-summary .help {\n    padding: 0.5rem;\n}\n\n.invoice-summary div:last-child {\n    border-bottom: 0;\n}\n\n.invoice-summary span:first-child {\n    color: #65746e;\n}\n\n.invoice-summary__total {\n    background: #ffffff;\n    font-size: 16px;\n}\n\n.invoice-form-alert {\n    margin-bottom: 0;\n}\n\n.invoice-form-actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    padding-top: 0.25rem;\n}\n\n.invoice-detail-actions,\n.invoice-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0;\n    align-items: center;\n    margin-bottom: 1rem;\n}\n.invoice-detail-actions {\n    gap: 1rem;\n}\n\n.invoice-customer-link {\n    margin-bottom: 1rem;\n}\n\n.invoice-customer-link label {\n    display: block;\n    margin-bottom: 0.35rem;\n    font-weight: 700;\n}\n\n.invoice-customer-link input,\n.message-compose textarea,\n.note-compose textarea {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #ccc;\n    font-family: \"Jost\", Arial, sans-serif;\n}\n\n.tab-button {\n    padding: 0.6rem 0.6rem;\n    border: 1px solid var(--invoice-border, #d9dedb);\n    background: #f7f9f8;\n    color: #1d2e23;\n    cursor: pointer;\n    font-weight: 700;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.tab-button.active {\n    background: var(--invoice-accent);\n    border-color: var(--invoice-accent);\n    color: #ffffff;\n}\n\n.invoice-tab-content {\n    border: 1px solid var(--invoice-border, #d9dedb);\n    padding: 1rem;\n    background: #ffffff;\n}\n\n.invoice-meta {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n}\n\n.invoice-line-items-table,\n.invoice-tab-content table {\n    margin-bottom: 1rem;\n}\n\n.invoice-totals {\n    margin-left: auto;\n    width: min(360px, 100%);\n}\n\n.invoice-totals div {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0.45rem 0;\n    border-bottom: 1px solid #e1e6e3;\n}\n\n.invoice-totals .total-row {\n    color: #1d2e23;\n    font-size: 16px;\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}\n\n@media (max-width: 900px) {\n    .invoices-summary-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .invoice-line-item-grid {\n        grid-template-columns: minmax(180px, 1fr) 82px 120px 130px 42px;\n    }\n}\n\n@media (max-width: 700px) {\n    .invoices-commandbar,\n    .invoices-commandbar__actions,\n    .invoices-actions,\n    .invoices-toolbar,\n    .invoice-form-actions,\n    .invoices-pagination {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .invoices-commandbar .button,\n    .invoices-commandbar__actions .button,\n    .invoices-actions .button,\n    .invoices-toolbar .button,\n    .invoice-form-actions .button,\n    .invoices-pagination .button {\n        width: 100%;\n    }\n\n    .invoices-summary-grid,\n    .invoice-payment-summary-grid,\n    .invoice-choice-grid,\n    .invoice-form-grid--two .invoice-subform,\n    .invoice-form-grid--three .invoice-subform,\n    .invoice-meta {\n        grid-template-columns: 1fr;\n    }\n\n    .invoice-line-item-grid--header {\n        display: none;\n    }\n\n    .invoice-line-item-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .invoice-line-item-field--description,\n    .invoice-line-item-total {\n        grid-column: 1 / -1;\n    }\n\n    .invoice-line-item-field span,\n    .invoice-line-item-total > span {\n        display: block;\n        margin-bottom: 0.35rem;\n        color: #65746e;\n        font-size: 12px;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n\n    .invoice-line-item-total {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .invoice-line-item-remove {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
